<app-smartsupp [username]="smartsuppUsername"></app-smartsupp>

<div class="container">

  <div class="login-container">
    <div class="row no-gutters">
      <div class="col-6 d-flex flex-column p-3">
        <h3 class="title">Please sign in with your first and last name</h3>

        <div *ngIf="errorMessage" class="alert alert-success font-size-12 px-3 py-1">
          {{errorMessage}}
        </div>

        <!--suppress AngularUndefinedBinding -->
        <form (ngSubmit)="login($event)" ngNativeValidate>
          <div class="form-group">
            <label for="inputname" class="sr-only">Name</label>
            <input type="text" id="inputname" name="name" class="form-control" placeholder="Your name" [(ngModel)]="loginData.name" required autofocus/>
          </div>
          <div class="form-group text-right">
            <button type="submit" id="sign_in_button" class="btn btn-primary">Sign In</button>
          </div>
        </form>

        <div class="alert alert-warning font-size-12 px-3 py-1" style="display:none;" id="cookie_disabled">
          Oops! Your browser seems to have cookies disabled. Make sure cookies are enabled or try opening a new browser window.
        </div>
      </div>
      <div class="col-6 login-right-img"></div>
    </div>
  </div>
</div>
